import './alteration-card-group.scss'

import { PropType } from 'vue'
import Component from "vue-class-component"
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons'

import { ThesaurusTerm, getTranslatedString } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { ThesaurusTermDataStore } from '@skinsoft/entity'
import { ReactiveVue } from "@skinsoft/reactive-vue"
import AlterationCardList from '../alteration-card-list'
import { ALTERATION_CARD_ALTERATION_UPDATED, ALTERATION_CARD_DELETE_ALTERATION, AlterationWithThesaurusTerm, MainAlterationCardField } from '../alteration-card'

export enum GroupingAlterationField {
    Title,
    AlterationType,
}

@Component({
    components: {
        sAlterationCardList: AlterationCardList,
    },
    props: {
        type: Array,
        alterations: {
            type: Array as PropType<AlterationWithThesaurusTerm[]>,
        },
        groupingField: {
            default: GroupingAlterationField.AlterationType
        },
        alterationTypeId: {
            type: String,
        },
        alterationTitle: {
            type: String,
        },
        readOnly: {
            type: Boolean,
        },
        existingTitles: {
            type: Array as PropType<String[]>,
            default:() => []
        },
    },
    template: require('./alteration-card-group.html')
})
export default class AlterationCardGroup extends ReactiveVue {
    private alterations: AlterationWithThesaurusTerm[]
    private alterationTypeId: string
    private alterationTitle: string
    private groupingField: GroupingAlterationField
    private readOnly: Boolean
    private existingTitles: String[]

    private isFolded = false

    private $thesaurusTermDataStore: ThesaurusTermDataStore

    private groupUnfoldedIcon = faCaretDown
    private groupFoldedIcon = faCaretRight

    private ALTERATION_CARD_DELETE_ALTERATION = ALTERATION_CARD_DELETE_ALTERATION
    private ALTERATION_CARD_ALTERATION_UPDATED = ALTERATION_CARD_ALTERATION_UPDATED

    private getThesaurusTermTitle(thesaurusTerm: ThesaurusTerm) {
        return getTranslatedString(
            thesaurusTermSelectors.preferredTerm(thesaurusTerm), 
            this.getAppLocale()
        )
    }

    private get groupFoldingIcon() {
        return this.isFolded ? this.groupFoldedIcon : this.groupUnfoldedIcon
    }

    private get alterationCardMainField(): MainAlterationCardField {
        switch(this.groupingField) {
            case GroupingAlterationField.AlterationType:
                return MainAlterationCardField.Title
            case GroupingAlterationField.Title:
                return MainAlterationCardField.AlterationType
        }
    }

    private get groupTitle() {
        if(this.alterations) {
            switch(this.groupingField) {
                case GroupingAlterationField.AlterationType:
                    if(this.alterations[0].typeOfAlterationObject){
                        return this.getThesaurusTermTitle(this.alterations[0].typeOfAlterationObject)
                    }
                    break
    
                case GroupingAlterationField.Title:
                    return getTranslatedString(this.alterations[0].title, this.getAppLocale())
            }
        }

        return ''
    }

    private toggleIsFolded() {
        this.isFolded = !this.isFolded
    }
}